var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 40,
    rx: 6,
    fill: "#e5e7eb",
    stroke: "#cbd5e1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 52,
    height: 6,
    fill: "#cbd5e1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 22,
    width: 30,
    height: 4,
    fill: "#cbd5e1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericCard);
export default __webpack_public_path__ + "static/media/generic-card.246d4779fb3614ef63cde392e39d4863.svg";
export { ForwardRef as ReactComponent };